module.exports = __webpack_public_path__ + "img/qiandao-7.cd050a04.png";